import React from 'react';
import { FlameIcon } from 'lucide-react';
type Props = {
  spotsLeft?: number;
  total?: number;
};
export function ScarcityBar({
  spotsLeft = 17,
  total = 200
}: Props) {
  const claimed = total - spotsLeft;
  const percent = Math.round(claimed / total * 100);
  return <div className="w-full max-w-xl rounded-2xl border border-white/15 bg-white/10 p-4" data-id="element-53" data-mp="2q40z2hxwskvb">
      <div className="flex items-center justify-between gap-3" data-id="element-54" data-mp="2q1o7re69gy5l">
        <p className="flex items-center gap-1.5 text-xs font-extrabold uppercase tracking-wide text-white sm:text-sm" data-id="element-55" data-mp="2b5yvi7qvnze2">
          <FlameIcon className="h-4 w-4 text-sky-400" aria-hidden="true" data-id="element-56" data-mp="2g74kpvlbx4iu" />
          Only {spotsLeft} spots left
        </p>
        <p className="text-xs font-semibold text-navy-100" data-id="element-57" data-mp="2755619xsecj2">
          at the $27 promo price
        </p>
      </div>
      <div className="mt-3 h-3 w-full overflow-hidden rounded-full bg-navy-900/60" role="progressbar" aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-58" data-mp="e5p2erq8ufs">
        <div className="h-full rounded-full bg-sky-500" style={{
        width: `${percent}%`
      }} data-id="element-59" data-mp="33ks7l97my5oc" />
      </div>
      <p className="mt-2 text-[11px] font-medium text-navy-100" data-id="element-60" data-mp="3dcesjx9rzj4a">
        {claimed} of {total} launch spots already claimed
      </p>
    </div>;
}